var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',[_vm._v("Custom Object Add Relationship")]),_c('VueFormGenerator',{attrs:{"schema":_vm.relationship.schema,"model":_vm.relationship.model,"options":_vm.relationship.formOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }